import React from 'react'
import Footer from '../Footer'
import Uml3 from '../Uml3'

function Umass3() {
    window.scrollTo(0,0);
    return (
        <div>
            <Uml3/>
            <Footer/>
        </div>
    )
}

export default Umass3
